export default function normalizeFields(object = {}, map = {}) {
  const normalized = {};
  Object.keys(map).map((field) => (normalized[map[field]] = object[field]));
  return normalized;
}
